<template>
  <div id="app">
    <header class="header" :class="{scrolled:isScrolled}">
      <a class="logo" href="javascript:;" @click.prevent="goSection('#main')">신세계세무회계</a>

      <nav class="main-navigation">
        <ul>
          <li><a href="#service" @click.prevent="goSection('#service')">서비스소개</a></li>
          <li><a href="#service-inheritance" @click.prevent="goSection('#service-inheritance')">상속세</a></li>
          <li><a href="#service-tax-agent" @click.prevent="goSection('#service-tax-agent')">기장</a></li>
          <li><a class="special" href="#request" @click.prevent="goSection('#request')">상담신청</a></li>
        </ul>
      </nav>

      <a class="tel-wrap" href="tel:02-964-2011">
        <span class="sub"><i class="fas fa-phone-alt icon"></i>상담문의</span>
        <span class="tel-number">02.964.2011</span>
      </a>
    </header>

    <main id="contents">
      <transition :name="transitionName" mode="out-in" @before-leave="beforeLeave" @enter="enter" @after-enter="afterEnter">
        <router-view/>
      </transition>
    </main>

    <footer class="footer">
      <div class="footer-info">
        <dl>
          <dt class="sr-only">상호</dt>
          <dd><strong>신세계세무회계컨설팅</strong></dd>
        </dl>
      </div>
      <div class="footer-info">
        <dl>
          <dt>대표</dt>
          <dd>이형석 세무사</dd>
        </dl>
        <dl>
          <dt>사업자등록번호</dt>
          <dd>157-21-01329</dd>
        </dl>
      </div>
      <div class="footer-info">
        <dl>
          <dt class="sr-only">주소</dt>
          <dd><address>서울특별시 동대문구 왕산로 239, 311호 힐스테이트 청량리역</address></dd>
        </dl>
      </div>
      <div class="footer-info">
        <dl>
          <dt>TEL</dt>
          <dd><a href="tel:02-964-2011">02.964.2011</a></dd>
        </dl>
        <dl>
          <dt>FAX</dt>
          <dd>02.964.2012</dd>
        </dl>
        <dl>
          <dt>Email</dt>
          <dd><a href="mailto:shin3@shin3tax.net">shin3@shin3tax.net</a></dd>
        </dl>
      </div>
      <div class="footer-info">
        <dl>
          <dt>개인정보관리책임자</dt>
          <dd>장선근 과장 (<a href="mailto:shin2@shin3tax.net">shin2@shin3tax.net</a>)</dd>
        </dl>
      </div>
      <p class="copyright">Copyright © 2020-2021 신세계세무회계컨설팅. All rights reserved.</p>
    </footer>
  </div>
</template>

<style lang="scss">
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>
<script>
const DEFAULT_TRANSITION = 'fade';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'Layout',
  data () {
    return {
      isScrolled: false,
      transitionName: DEFAULT_TRANSITION
    }
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll)
    this.handleScroll()

    if(isMobile) {
      window.SmoothScroll.destroy()
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.isScrolled = $(window).scrollTop() > 0
    },
    goSection( element ) {
      if(this.$route.path === '/') {
        this.moveMainSection (element)
      }
      else {
        this.$router.push('/'+element)
      }
    },
    moveMainSection( element ) {
      let targetY = $(element).offset().top;

      $('html,body').stop().animate({
        scrollTop: targetY
      }, 450, 'easeInOutCubic', ()=>{
        window.location.hash = element === '' ? null : element;
      });
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    }
  }
}
</script>
